import * as React from 'react';
import * as I18n from 'i18n-js';
import TogglableDropdown from './payout_method_dropdown';

interface Props {
  currencyCode: string;
  onCurrencyChange(currencyCode: string): void;
  inputName: string;
  currencyCodes: string[];
}

function selectOptions(currencyCodes: string[]) {
  return currencyCodes.map((currencyCode) => ({ name: currencyCode, value: currencyCode }));
}

export default function PayoutMethodCurrencyInput(props: Props) {
  return (
    <div className="g-col-6" data-change-currency>
      <TogglableDropdown
        defaultValue={props.currencyCode}
        selectOptions={selectOptions(props.currencyCodes)}
        inputName={props.inputName}
        onChange={props.onCurrencyChange}
        labelTitle={I18n.t('discovery.payoutMethod.directCheckoutProfile.bankAccountFields.currencyInput.label')}
        changeLinkText={I18n.t('discovery.payoutMethod.directCheckoutProfile.bankAccountFields.currencyInput.change')}
        autoComplete="currency-code"
      />
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/payout_method_currency_input.tsx